import styles from "./joshua.module.css"

function Footer(props) {
  return (
    <p className={styles.footer}>&copy; 2024 | <a className={styles.footerLink} href="https://instagram.com/joshua.hoff">@joshua.hoff</a> | {props.link}</p>
  );
}

export default Footer;
